import { useContext } from "react";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LayoutContext } from "../../context/LayoutContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

export default function SidebarBack({ overlay }) {
  const navigate = useNavigate();
  const { collapsed } = useContext(LayoutContext);

  return (
    <ListItemButton
      onClick={() => navigate("/dashboard", { replace: true })}
      sx={{
        mx: 1,
        borderRadius: 2,
        py: 1.4,
        mt: 1,
        alignItems: "center",
        gap: 2,
        color: "#fff",
        "&:hover": { bgcolor: "rgba(255,255,255,0.10)" },
      }}
    >
      <ListItemIcon
        sx={{
          color: "#fff",
          minWidth: 0,
          display: "flex",
          justifyContent: "center",
          mr: collapsed && !overlay ? 0 : 2,
        }}
      >
        <ArrowBackIcon />
      </ListItemIcon>

      {(!collapsed || overlay) && (
        <ListItemText
          primary="Back"
          slotProps={{
            primary: { sx: { fontSize: 16, fontWeight: 600 } },
          }}
        />
      )}
    </ListItemButton>
  );
}
